import { ArtistGenre as GQLItem } from '../../generated/api.graphql';
import { take } from '../../util';

export type ArtistGenre = {
  root?: string;
  sub?: string[];
};

export const fromGql = (item: GQLItem): ArtistGenre => ({
  ...take<ArtistGenre>(item, 'root'),
  sub: item.sub || [],
});
